import { IDictionary } from '~/services/api/dictionaries/types';
import { IOption } from '~/types';

export default (teams: IDictionary[]): IOption[] =>
  teams.map(item => ({ value: item.id, label: item.name }));
